
import { useState } from 'react';
import Logo from '../../../components/base/Logo';

const GoogleMapsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-16">
            <Logo />
            
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Главная</a>
              <a href="/blog"ClassName="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Блог</a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Услуги</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Контакты</a>
            </nav>
          </div>
        </div>
      </nav>

      {/* ... rest of existing code without logo uploader functionality ... */}

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <Logo className="text-white mb-4" />
              <p className="text-gray-400">
                Профессиональное SEO продвижение сайтов с гарантией результата
              </p>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Услуги</h4>
              <ul className="space-y-2">
                <li><a href="/services/seo-audit" className="text-gray-400 hover:text-white transition-colors cursor-pointer">SEO Аудит</a></li>
                <li><a href="/services/yandex-seo" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Продвижение в Яндекс</a></li>
                <li><a href="/services/google-seo" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Продвижение в Google</a></li>
                <li><a href="/services/google-maps" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Google Карты</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Компания</h4>
              <ul className="space-y-2">
                <li><a href="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Блог</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">О нас</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Кейсы</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Контакты</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibール mb-4">Контакты</h4>
              <ul className="space-y-2 text-gray-400">
                <li>+7 (950) 360-35-20</li>
                <li>info@seo-agency.ru</li>
                <li>Москва, ул. Примерная, 123</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 SEO Продвижение. Все права защищены. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-1">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GoogleMapsPage;
